import type { League, LeaderboardEntry } from '@/types';

/** The signed-in manager's team, used to highlight their leaderboard row. */
export const CURRENT_MANAGER = 'Alex Morgan';

type Seed = Omit<LeaderboardEntry, 'id' | 'rank' | 'isCurrentUser'>;

const SEED: readonly Seed[] = [
  { manager: 'David Okafor', team: 'Kampala Comets', points: 82, movement: 'up', movedBy: 4 },
  { manager: CURRENT_MANAGER, team: 'Mumbai Strikers', points: 68, movement: 'up', movedBy: 2 },
  { manager: 'Sarah Blake', team: 'Northside XI', points: 64, movement: 'down', movedBy: 1 },
  { manager: 'John Kim', team: 'Weekend Warriors', points: 61, movement: 'up', movedBy: 3 },
  { manager: 'Ravi Shah', team: 'Late Tacklers', points: 59, movement: 'same', movedBy: 0 },
  { manager: 'Mia Lewis', team: 'The Press', points: 57, movement: 'up', movedBy: 6 },
  { manager: 'Tobi Mensah', team: 'Golden Boots', points: 54, movement: 'down', movedBy: 2 },
  { manager: 'Liam Scott', team: 'Red Star XI', points: 51, movement: 'same', movedBy: 0 },
];

export const MOCK_LEADERBOARD: readonly LeaderboardEntry[] = SEED.map((entry, i) => ({
  ...entry,
  id: `rank-${i + 1}`,
  rank: i + 1,
  isCurrentUser: entry.manager === CURRENT_MANAGER,
}));

export const MOCK_LEAGUES: readonly League[] = [
  {
    id: 'weekly',
    name: 'Weekly Challenge',
    kind: 'Weekly league',
    period: 'GW05',
    activeManagers: 2480,
    yourRank: 31,
    yourPoints: 68,
  },
  {
    id: 'monthly',
    name: 'August Elite',
    kind: 'Monthly league',
    period: 'August',
    activeManagers: 11892,
    yourRank: 84,
    yourPoints: 296,
  },
];
